import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { PAYMENT_FEATURE } from './payment-state';
import { reducerProvider, reducerToken } from './reducers/index';

@NgModule({
  imports: [StoreModule.forFeature(PAYMENT_FEATURE, reducerToken)],
  providers: [reducerProvider],
})
export class PaymentStoreModule {}
